<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        class="text-center"
      >
        <v-icon v-if="isStarred" @click="emitStatus(false)" color="yellow darken-2" x-large>mdi-star</v-icon>
        <v-icon v-else @click="emitStatus(true)" color="grey lighten-1" x-large>mdi-star-outline</v-icon>
      </div>
    </template>
    <span class="body-2">
      {{ $t(`host.label.${ isStarred ? 'unfavorite' : 'favorite'}`) }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'HostFavorite',

  props: {
    starred: {
      type: Boolean,
      default: false,
    }
  },

  watch: {
    starred(value) {
      this.emitStatus(value)
    }
  },

  methods: {
    emitStatus(value) {
      this.$emit('setStarred', value)
      this.isStarred = value
    }
  },

  data() {
    return {
      isStarred: this.starred,
    }
  }
}
</script>
